module.exports = __webpack_public_path__ + "img/ruido_hover.9a62477e.png";